import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { Link, useLocation } from "react-router-dom";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { sbaAxios } from "../../utils/sbaAxios";
import { getContactsDetailsAction, getContactsHeaderAction } from "../../actions/contactsAction";
import { UrlPath } from "../../../config/routeConfig";
import { getGetEnumeration, updateContactHeader, deleteContactImage,getCompanyInfo, getUserPageAccess} from "../../../config/apiConfig";
import { TopBar } from "../../shared/topBar/TopBar";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Companys } from "./companyInfo/Companys";
import { Badge, Col, Image} from "react-bootstrap";
import SampleProfile from "./../investorDetails/sampleImage/ProfileImage.png"
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { ToastContainer, toast } from 'react-toastify';
import { SBADropDown } from "../../UiComponents/SBADropDown";
import { SBNotify } from "../../utils/sbNotify";
import "../../investor/investor.css";

export const CompanyDetails = () => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const params = useParams(); 
  const locationData = useLocation();

  const Gstate = useSelector((state) => state) || {};

  const isEditable = Gstate.authorizationData.isEditable;

  const ContactsHeader = Gstate?.Contacts.ContactsHeader || [];
  const ContactDetails = Gstate?.Contacts.ContactDetails || [];

  const [render, setRender] = useState(true);
  const [loading, setLoading] = useState(true);
  const [dataUri, setDataUri] = useState('');
  const [showDrawer, setshowDrawer] = useState(false);
  const [base64Data, setBase64Data] = useState(null);
  const [isActive, setIsActive] = useState("");
  const [investmentStatusData, setInvestmentStatusData] = useState([]);
  const [investmentStatusValue, setInvestmentStatusValue] = useState({});
  const [companydetails,SetCompanyDetails]=useState([]);
  const [isContactHovered, setIsContactHovered] = useState(false);
  const [isCompanyHovered,setIsCompanyHovered]= useState(false);
  const [investorPremission,setInvestorPersmission]=useState(false);
  const [investmentPremission,setInvestmentPersmission]=useState(false);
  const loadPermission=async()=>{
    await sbaAxios({ url: `${getUserPageAccess}?keyName=ContactInvestorAccess` }).then(res=>setInvestorPersmission(res));
    await sbaAxios({ url: `${getUserPageAccess}?keyName=ContactInvestmentAccess` }).then(res=>setInvestmentPersmission(res))  
  };

  useEffect(() => {
    document.title = `Company Details`;
    getCompanyDetails(params.CompanyId);
    loadPermission();
   // dispatch(getContactsHeaderAction(params.ContactId));
   
  }, []);
  // useEffect(() => {
  //    companydetails  && setLoading(false);
  // }, [ ContactDetails]);
  useEffect(() => {
    if(ContactsHeader ){
     setBase64Data(ContactsHeader.ContactImageFile);
     setIsActive(ContactsHeader.IsActive);
     
    }
  }, []);
  let Level = [{ BreadCrumb: "Company > ", Routes: `${UrlPath.Investor}` }];

  Level = loading
    ? Level
    : [
      ...Level,
      {
        BreadCrumb: `${companydetails?.CompanyInfo?.CompanyName}`,
        Routes: `${UrlPath.CompanyDetails}${params.CompanyId}`,
      },      
    ];




const getCompanyDetails = async (companyId) => {
  try {

      const response = await sbaAxios({
          url: `${getCompanyInfo}${companyId}`,
          method: 'get',
      });
      const data = response;
      SetCompanyDetails(data);
      setLoading(false);
  } catch (error) {
      console.error("Error fetching entities from API:", error);
  }
};


const headerEditClick = () => {
  if(isEditable !== false){
    setshowDrawer(true);
  }
};

const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = function () {
      if (reader.result) {
        const arrayBuffer = reader.result;
        const base64String = arrayBufferToBase64(arrayBuffer);
        setBase64Data(base64String);
        if (base64String) {
          setDataUri(`data:image/png;base64,${base64String}`);
        }
      }
    };
    reader.readAsArrayBuffer(file);
  }
};

const arrayBufferToBase64 = (arrayBuffer) => {
  const binary = [];
  const bytes = new Uint8Array(arrayBuffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary.push(String.fromCharCode(bytes[i]));
  }
  return btoa(binary.join(''));
};

const handleDeleteImage = () => {
  deleteImage();
  setRender(!render);
  getContactsHeaderAction();
};

const deleteImage = () => {

  const imageId = ContactsHeader.ContactImageId;
  const contactId = ContactsHeader.ContactId;

    const response = sbaAxios({
      url: `${deleteContactImage}${imageId},${contactId}`,
      method: "get",
    });
    if (response) {
      SBNotify({ type: "success", Msg: "Image Deleted Successfully" });
    }
      else {
        SBNotify({ type: "warning", Msg: "Failed to Delete" });
      }
  };

const toggleSwitch = () => {
  setIsActive(!isActive);
};

const statusDataChange = (e) => {
  setInvestmentStatusValue({EnumName: e.value.EnumName ,EnumValue: e.value.EnumValue});
};

const closeDrawer = () => {
  setshowDrawer(false);
  setRender(!render);
};

const UpdateContactHeader = async () => {

  let saveSuccess = true;
  let errorMsg = [];

  const data = {
    "contactId": ContactsHeader.ContactId,
    "contactImageId": ContactsHeader.ContactImageId !== 0 ? ContactsHeader.ContactImageId : null,
    "contactImageFile": base64Data,
    "isActive": isActive,
    "contactInvestmentStatusId": investmentStatusValue.EnumValue,
    "modifiedBy": 0,
  };

  if (saveSuccess) {
    const response = await sbaAxios({
      url: `${updateContactHeader}`,
      method: "post",
      data: data,
    });
    if (response > 0) {
      SBNotify({ type: "success", Msg: "Updated Successfully" });
      setRender(!render);
      setshowDrawer(false);
    }
      else {
        SBNotify({ type: "warning", Msg: "Failed" });
      }
    }   
  };

const navigateToAddNewAccount = () => {
  history(`${UrlPath.InvestorAccountAdd}`);
}

const navigateToAddNewContact = () => {
  history(`${UrlPath.InvestorDetailsEdit}${0}`);
};

const navigateToAddNewCompany = () => {
  history(`${UrlPath.CompanyDetailsEdit}${0}`);
};

const previouslyActiveTab =
locationData.state === null ? "Company" : locationData.state.ActiveTab;
const buttonList=getAccessButton(investmentPremission,investorPremission);

  return (
    <>
     
        <>
          <TopBar label={"Company"} />
          <div id="content" className="asset-detail-screen">
            <BreadCrumbs Levels={Level} />
            <div className="container-fluid">
                  <div className="col-lg-12">
                    <div className="row d-flex">
                    
                      
                     
                      <div className="col-md-12">
                      <div className="mb-0">
                          <span className="fw-medium custom-font-size">
                            {companydetails?.CompanyInfo?.CompanyName}
                          </span>
                        </div>
                      <div className="d-flex justify-content-end">
                        <button
                          type="submit"
                          className="p-sm-btn mx-1"
                          disabled={!isEditable}
                          onClick={navigateToAddNewAccount}
                        >
                          <i className="fa-solid fa-plus" /> New Account
                        </button>
                        <div>
                        <button
                          type="submit"
                          className="p-sm-btn mx-1"
                          disabled={!isEditable}
                          onMouseEnter={() => setIsContactHovered(true)}
                          onMouseLeave={() =>setIsContactHovered(false)}
                        >
                          <i className="fa-solid fa-plus" /> New Contact
                        </button>
                        {isContactHovered && <><HoverList buttonList={buttonList} isContact={"Contact"} setHoverState={setIsContactHovered}/></>}
                       </div>
                        <div>
                        <button
                          type="submit"
                          className="p-sm-btn mx-1"
                          disabled={!isEditable}
                          onMouseEnter={() => setIsCompanyHovered(true)}
                          onMouseLeave={() =>setIsCompanyHovered(false)}
                        >
                          <i className="fa-solid fa-plus" /> New Company
                        </button>
                        {isCompanyHovered && <><HoverList buttonList={buttonList}  isContact={"Company"} setHoverState={setIsCompanyHovered}/></>}
                      </div>
                      </div>
                    </div>
                    </div>
                  </div>

                 
                
             

              <div className="p-4">
                <Tabs
                  defaultActiveKey={previouslyActiveTab}
                  id="uncontrolled-tab-example"
                  className="ms-3"
                >
                  <Tab eventKey="Company" title="Company">
                    <div className="p-3 bg-white life-science rounded px-0">
                      <Companys/>
                    </div>
                  </Tab>

                </Tabs>
              </div>
            </div>
          </div>

          <SBADrawer
            open={showDrawer}
            setOpen={setshowDrawer}
            close={false}
            title={"Update Header"}
          >
            <div>
              <div className="mb-4">
                <div>
                <Col xs={2} md={1} lg={1}>
                  <Image
                    src={dataUri ? dataUri : SampleProfile}
                    rounded
                    style={{ width: "200%", height: "120px" }}
                  />
                </Col>
                </div>
                <div><i class="fa-solid fa-xmark" onClick={handleDeleteImage}></i></div>
              </div>
              <div className="mb-4">
                <input
                  id="fileInput"
                  type="file"
                  accept=".png, .jpg, .jpeg, image/*"
                  onChange={handleFileChange}
                />
              </div>
              <div className="col-md-6">
                <div className="mb-4">
                  <span className="fw-medium">Investment Status</span>
                  <div>
                    <SBADropDown
                      className="w-75"
                      data={investmentStatusData}
                      textField={"EnumName"}
                      valueField={"EnumValue"}
                      value={investmentStatusValue}
                      onChange={statusDataChange}
                      popupSettings={{ className: 'modalDD' }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-4">
                  <span className="fw-medium">User Status</span>
                  <div>
                    <label
                      className={`switch ${
                        ContactsHeader.IsActive ? "active" : "inactive"
                      }`}
                    >
                      <input
                        type="checkbox"
                        checked={isActive}
                        onChange={toggleSwitch}
                      />
                      <span
                        className={`slider round ${
                          isActive ? "bg-success" : "bg-danger"
                        }`}
                      ></span>
                    </label>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <button className="s-sm-btn mx-1" onClick={closeDrawer}>
                  Cancel
                </button>
                <button className="p-sm-btn mx-1" onClick={UpdateContactHeader}>
                  Save
                </button>
              </div>
            </div>
          </SBADrawer>
        </>
     
      <ToastContainer />
    </>
  );
};
const HoverList=({buttonList,setHoverState,isContact})=>{
  const history = useNavigate();
  const handleItemClick = (item) => {
    if(isContact=="Contact")
    {
   if(item=="Investor")
   history(`${UrlPath.InvestorDetailsEdit}${0}?ContactTypeId=1`);
   else
   history(`${UrlPath.InvestorDetailsEdit}${0}?ContactTypeId=2`);
    }
    else
    {
      if(item=="Investor")
      history(`${UrlPath.CompanyDetailsEdit}${0}?ContactTypeId=1`);
      else
      history(`${UrlPath.CompanyDetailsEdit}${0}?ContactTypeId=2`);
    }
  };

  return <div className="list-of-items mx-1 text-center" style={{width:"150px"}} onMouseEnter={()=>{setHoverState(value=>true)}} onMouseLeave={()=>{setHoverState(value=>false)}}>
  {buttonList.map((item,index) => (
    <div className={index+1==buttonList.length ?  " "  : "border-bottom"}
      key={item}
      onClick={() =>handleItemClick(item)}
    >
      {item}
    </div>
  ))}
</div>
}

function getAccessButton(investment,investor){
  const output=[]
  if(investment)
  output.push("Investment");
  if(investor)
  output.push("Investor");
  return output;
}